/**
 * Analytics API Configuration
 * Extends ApiConfigBase with analytics-specific endpoints
 */

import ApiConfigBase from '@shared/config/ApiConfigBase';

class AnalyticsApiConfig extends ApiConfigBase {
  constructor() {
    super();
    this.loadAnalyticsConfig();
  }

  loadAnalyticsConfig() {
    // All analytics microservices route through API Gateway
    this.SENTIMENT_SERVICE_URL = `${this.API_GATEWAY_URL}/sentiment`;
    this.ANALYTICS_SERVICE_URL = `${this.API_GATEWAY_URL}/analytics`;
    this.QA_SERVICE_URL = `${this.API_GATEWAY_URL}/qa`;
    this.COMPLIANCE_SERVICE_URL = `${this.API_GATEWAY_URL}/compliance`;
    this.CONNECTOR_SERVICE_URL = `${this.API_GATEWAY_URL}/connectors`;
    this.LOCATION_SERVICE_URL = `${this.API_GATEWAY_URL}/locations`;
  }

  getSentimentServiceUrl() {
    return this.SENTIMENT_SERVICE_URL;
  }

  getAnalyticsServiceUrl() {
    return this.ANALYTICS_SERVICE_URL;
  }

  getQAServiceUrl() {
    return this.QA_SERVICE_URL;
  }

  getComplianceServiceUrl() {
    return this.COMPLIANCE_SERVICE_URL;
  }

  getConnectorServiceUrl() {
    return this.CONNECTOR_SERVICE_URL;
  }

  getLocationServiceUrl() {
    return this.LOCATION_SERVICE_URL;
  }
}

const apiConfig = new AnalyticsApiConfig();

export default apiConfig;
